export enum ColumnOutputType {
  Text = 0,
  Link = 1,
  Checkbox = 2,
  MultilineText = 3,
  Custom = 4,
  DropdownLabel = 5,
}
